import {request } from "../../api/api"

export const logout = () => {
    return request.post('/user/logout/')
}

export const plantUIDPrintSummary = (params) => {
    return request.get(`/print_summary/plantUIDPrintSummary/?page=${params.page}&page_size=${params.rowsPerPage}`)
}
export const getPrinterHealth = (searchParams) => {
    console.log("searchParams", searchParams);
    const params = new URLSearchParams();
  
    if (searchParams.page !== undefined) params.append("page", searchParams.page + 1);
    if (searchParams.rowsPerPage !== undefined) params.append("page_size", searchParams.rowsPerPage);
  
    const search = searchParams.search || {};
  
    if (search.plant) params.append("plant__name__icontains", search.plant);
    if (search.extruder) params.append("extruder__name__icontains", search.extruder);
    if (search.line) params.append("line__icontains", search.line);
    if (search.emergency) params.append("emergency_alarm_time", search.emergency);
    if (search.cij) params.append("cij_alarm_time", search.cij);
    if (search.nij) params.append("nij_alarm_time", search.nij);
    if (search.uidCount) params.append("uid_count_alarm_time", search.uidCount);
    if (search.IiotAlarm) params.append("iiot_alarm_time", search.IiotAlarm);
    if (search.printer) params.append("printer_alarm_time", search.printer);
    if(searchParams.start_datetime) params.append("start_datetime", searchParams.start_datetime)
    if(searchParams.end_datetime) params.append("end_datetime", searchParams.end_datetime
    )
  
    return request.get(`/alarm_status/getPrinterHealthStatus/?${params.toString()}`);
  };
  
  export const getExportData = async(params)=>{
    return request.post("/alarm_status/exportPrinterHealthStatusExcel/",params)
  }
  